// src/pages/Upload/UploadLayout.jsx
import React from "react";
import { Routes, Route, useNavigate, useLocation, Navigate, useParams } from "react-router-dom";
import Hero from "../../../components/ui/Hero.jsx";
import ProductSelectModal from "./ProductSelectModal.jsx";
import ManualEntryPage from "./ManualEntryPage.jsx";
import CsvUploadPage from "./CsvUploadPage.jsx";
import UploadIndex from "./UploadIndex.jsx";

// ✅ shared upload state (mirrors filenames/sizes across tabs)
import { UploadProvider } from "./uploadStore.js";

const BASE_PATH = "/lender/upload"; // ✅ Portal base route (used everywhere)

function ManualEntryRoute() {
  const { ptype } = useParams();
  if (ptype === "btl") return <ManualEntryPage />;
  return <Navigate to="/lender/upload/select" replace />;
}

export default function UploadLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  // If we navigated with { state: { suppressModal: true } }, don't auto-open
  const suppressModal = location.state?.suppressModal === true;

  // ✅ Fixed: stays inside lender portal
  const closeToIndex = () =>
    navigate(BASE_PATH, { replace: true, state: { suppressModal: true } });

  return (
    <UploadProvider>
      <Routes>
        {/* /pages/upload — shows UploadIndex, auto-opens modal unless suppressed */}
        <Route
          index
          element={
            <>
              <UploadIndex />
              {!suppressModal && <ProductSelectModal onClose={closeToIndex} />}
            </>
          }
        />

        {/* /pages/upload/select — still supported; closing returns to UploadIndex */}
        <Route
          path="select"
          element={
            <>
              <Hero
                title="Upload Products"
                subtitle="Choose a product category to begin"
              />
              <ProductSelectModal onClose={closeToIndex} />
            </>
          }
        />

        {/* Manual entry: BTL only. IF is CSV-only. */}
        <Route
          path="if/manual"
          element={<Navigate to="/lender/upload/if/csv" replace />}
        />
        <Route path=":ptype/manual" element={<ManualEntryRoute />} />
        <Route path=":ptype/csv" element={<CsvUploadPage />} />

        {/* Back-compat routes fall back to same modal-based experience */}
        <Route
          path="manual"
          element={
            <>
              <UploadIndex />
              {!suppressModal && <ProductSelectModal onClose={closeToIndex} />}
            </>
          }
        />
        <Route
          path="csv"
          element={
            <>
              <UploadIndex />
              {!suppressModal && <ProductSelectModal onClose={closeToIndex} />}
            </>
          }
        />
      </Routes>
    </UploadProvider>
  );
}

